// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleApiTokenManager = {
  id: "api-token-manager",
  mrn: "//iam.api.mondoo.app/roles/api-token-manager",
  title: "API Token Manager",
  allowedActions,
} as const;

export type RoleApiTokenManager = typeof roleApiTokenManager;
